import React from 'react';
import Badge from 'housecall-ui/dist/DesignSystem/DataDisplay/Badges/Badge';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';

type LabelWithBadgeProps = {
  children: React.ReactNode;
  badgeCount?: number;
};

const LabelWithBadge = ({ children, badgeCount }: LabelWithBadgeProps) => (
  /* eslint-disable @typescript-eslint/ban-ts-comment */
  /* @ts-ignore */
  <Badge color="info" badgeContent={badgeCount} version="v2">
    <Typography variant="subtitle2" color="textPrimary">
      {children}
    </Typography>
  </Badge>
);

export default LabelWithBadge;
